import React from "react";
// import { useEffect } from 'react';
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import "./AboutMe.css";

// Hoisted to module scope — doesn't use component state, so rebuilding it on
// every render wastes work and makes it look new each time (breaks memoized children)
const SCREEN_CONSTANTS = {
  // Split so "CoreBridge Systems" can render as a link to the company site
  // without turning the whole description into a component.
  description: {
    before:
      "I'm Chris Bolosan, a software engineer in the Chicago area and the Founding Software Engineer of ",
    linkLabel: "CoreBridge Systems",
    linkHref: "https://www.corebridgesystems.io/",
    after:
      ". I build full-stack web applications — React and TypeScript on the front end, Python and Node services behind them — and I've shipped production front ends and AI-agent features. I'm finishing a B.S. in Computer Science at Northern Illinois University.",
  },
  highlights: {
    bullets: [
      "Full-stack web development, front to back",
      "React, TypeScript, and Next.js front ends",
      "Python/FastAPI services and REST APIs",
      "Database design with PostgreSQL and MySQL",
      "CRM and marketing automation with HubSpot",
      "AI-agent and generative-AI features",
    ],
    heading: "What I do:",
  },
};

// Named component at module scope — inline function calls (renderHighlight()) give React
// no stable identity, causing unnecessary remounts. A named component fixes that.
function HighlightBullet({ value }) {
  return (
    <div className="highlight">
      <div className="highlight-blob"></div>
      <span>{value}</span>
    </div>
  );
}

export default function AboutMe(props) {
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInScreen(props.id);
  };
  // const fadeInSubscription = //turn on later
  ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  return (
    <div
      className="about-me-container screen-container fade-in"
      id={props.id || ""}
    >
      <div className="about-me-parent">
        <ScreenHeading title={"About Me"} subHeading={"A bit about me"} />
        <div className="about-me-card">
          <div className="about-me-profile"></div>
          <div className="about-me-details">
            <span className="about-me-description">
              {SCREEN_CONSTANTS.description.before}
              <a
                href={SCREEN_CONSTANTS.description.linkHref}
                target="_blank"
                rel="noreferrer"
                className="about-me-link"
              >
                {SCREEN_CONSTANTS.description.linkLabel}
              </a>
              {SCREEN_CONSTANTS.description.after}
            </span>
            <div className="about-me-highlights">
              <div className="about-me-heading">
                <span>{SCREEN_CONSTANTS.highlights.heading}</span>
              </div>
              {/* key=value uses the bullet text as a stable id — index keys break when the list reorders */}
              {SCREEN_CONSTANTS.highlights.bullets.map((value) => (
                <HighlightBullet key={value} value={value} />
              ))}
            </div>
            <div className="about-me-options">
              {/* <button
                className="btn primary-btn"
                // onClick={() => ScrollService.scrollHandler.scrollToHireMe()}
              > */}
              <a
                className="btn primary-btn"
                href="mailto:cbolosan@gmail.com"
                target="_blank"
                rel="noreferrer"
              >
                Email Me
              </a>{" "}
              {/* </button> */}
              {/* <a
                href="Christopher Bolosan Resume.pdf"
                download="Christopher Bolosan Resume.pdf"
              >
                <button className="btn highlighted-btn">Get Resume</button>
              </a> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
